<div class="p-dialog-header px-0">
  <div class="p-dialog-title">
    <div class="flex gap-spacing-xs align-items-center">
      <span class="title-small-bold text-primary-color">Add Waiting Time to Ride</span>
    </div>
  </div>
  <div class="p-dialog-header-icons">
    <app-button
      (btnClick)="ref.close()"
      [iconOnlyButton]="true"
      icon="icon-x"
      sizeClass="p-button-sm"
      severity="secondary"
      [textButton]="true"></app-button>
  </div>
</div>

<div class="content p-spacing-xl border-1 border-neutral-base-primary-border border-round-lg flex flex-column gap-spacing-xl table-bg-hover-bg">
  <form
    #form="ngForm"
    class="flex flex-column gap-spacing-xl">
    <div class="flex align-items-start flex-wrap">
      <div class="col-12 md:col-6 flex flex-column gap-spacing-xs">
        <label
          class="input-label label-large-medium text-primary-color"
          for="reasonInput">
          Waiting Time
        </label>
        <div class="form-group">
          <div class="k-input-wrapper">
            <p-inputNumber
              class="w-full p-inputtext-sm"
              #waitingTimeInp="ngModel"
              [(ngModel)]="waitingTimeInMinutes"
              name="waitingTime"
              inputId="waitingTime"
              required
              (onBlur)="updatePayout()"
              [style]="{ width: '100%' }" />
            <em class="right-icon">Min</em>
          </div>
          @if (waitingTimeInp.dirty && waitingTimeInp.errors && waitingTimeInp.errors["required"]) {
            <small class="input-helper-text label-medium-regular text-danger-color">This field is required.</small>
          }
        </div>
      </div>
      <div class="col-12 md:col-6 flex flex-column gap-spacing-xs">
        <label
          class="input-label label-large-medium text-primary-color"
          for="reasonInput">
          Waiting Time Payout
        </label>
        <div class="form-group">
          <div class="k-input-wrapper">
            <em class="left-icon icon-currency-dollar"></em>
            <p-inputNumber
              class="w-full p-inputtext-sm"
              readonly
              #waitingTimePayoutRef="ngModel"
              [(ngModel)]="waitingTimePayout"
              name="waitingTimePayout"
              inputId="waitingTimePayout"
              mode="decimal"
              placeholder="0.00"
              [style]="{ width: '100%' }"
              [maxFractionDigits]="2" />
          </div>
        </div>
      </div>
    </div>

    <div class="form-group flex flex-column gap-spacing-xs">
      <label
        class="input-label label-large-medium text-primary-color"
        for="reasonInput">
        Pay Type
      </label>
      <div class="form-group">
        <p-select
          [(ngModel)]="selectedPaymentType"
          name="paymentType"
          required
          [options]="paymentTypeOptions()"
          optionLabel="name"
          optionValue="id"
          placeholder="Payable & Reveivable" />
      </div>
    </div>

    <div class="form-group flex flex-column gap-spacing-xs">
      <label
        class="input-label flex flex-column gap-spacing-default body-medium-medium text-secondary-color"
        for="reasonInput"
        >Reason
        <span class="body-small-medium text-caption-color">The reason for why you are adding waiting time for this ride.</span>
      </label>
      <p-autoComplete
        #reasonInput="ngModel"
        #autoCompleteRef
        [(ngModel)]="reason"
        name="reason"
        required
        [suggestions]="filteredSuggestions"
        (completeMethod)="filterSuggestions($event, autoCompleteRef)"
        (onFocus)="filterSuggestions($event, autoCompleteRef)"
        [showEmptyMessage]="false"
        appendTo="body"
        inputStyleClass="px-spacing-md pt-spacing-md"
        [style]="{ width: '100%' }"
        [inputStyle]="{ paddingBottom: '72px', height: '100px' }"
        placeholder="Select or enter a reason." />
    </div>

    <div class="flex align-items-center">
      <p-checkbox
        [(ngModel)]="isApproved"
        ngModel
        name="isConfirmed"
        [binary]="true"
        inputId="isConfirmed"></p-checkbox>
      <label
        class="p-checkbox-label cursor-pointer label-large-regular form-label-color"
        for="isConfirmed">
        I confirm one of the conditions in the note(s) below applies.
      </label>
    </div>
  </form>
  <div class="warning-messages border-round-md p-spacing-md background-muted-warning-bg flex gap-spacing-xs align-items-center">
    <i class="icon-warning-solid text-xl icon-warning-color"></i>
    <ul class="mb-0 pl-spacing-2xl">
      <li class="label-large-regular text-warning-color">I received client approval to add waiting time, and I entered the client communication above.</li>
      <li class="label-large-regular text-warning-color">There was no one to receive the student at the drop-off location, and so we authorized this charge.</li>
    </ul>
  </div>
</div>

<div class="footer pb-spacing-3xl pt-spacing-4xl px-0 gap-spacing-xl flex justify-content-end gap-spacing-xl">
  <app-button
    label="Cancel"
    (btnClick)="ref.close()"
    sizeClass="p-button-md"
    severity="secondary"></app-button>
  <app-button
    [label]="config.data.isEdit ? 'Edit Waiting Time' : 'Add Waiting Time'"
    [isLoading]="loading"
    [disabled]="loading || !!form?.invalid || reasonInput.value?.trim().length <= 0"
    [iconStart]="loading ? 'icon-spinner-gap' : ''"
    (btnClick)="confirmAction(form)"
    sizeClass="p-button-md"
    severity="primary">
  </app-button>
</div>
